import { gql } from '@apollo/client';

import { apolloClient } from '@sbu/contexts.apollo';
import { GraphqlContextValues } from '@sbu/contexts.graphql';

import {
  SearchFilterQueryOperationQuery as SearchFilterQueryOperation,
  SearchFilterQueryOperationQueryVariables as SearchFilterQueryOperationVariables,
  SearchResultType,
} from 'core/graphql';

export const SEARCH_FILTER_QUERY = gql`
  query SearchFilterQueryOperation(
    $query: String!
    $resultType: SearchResultType!
    $fieldName: String!
    $limit: Int
  ) {
    searchFieldSuggestions(
      query: $query
      resultType: $resultType
      fieldName: $fieldName
      limit: $limit
    ) {
      total
      objects {
        value
      }
    }
  }
`;

export const autocompleteQuery = async (
  resultType: SearchResultType,
  fieldName: string,
  query: string,
  context: GraphqlContextValues
) => {
  const result = await apolloClient.query<
    SearchFilterQueryOperation,
    SearchFilterQueryOperationVariables
  >({
    query: SEARCH_FILTER_QUERY,
    variables: {
      fieldName,
      query,
      resultType,
      limit: 5,
    },
    context: {
      targetGraph: 'ADMIRAL',
      ...context,
    },
  });

  return result?.data?.searchFieldSuggestions.objects.map((o) => o.value) || [];
};
